<template>
  <Toggle
    :checked="modelValue"
    label-after="Save for future payments"
    subheader-after="Replaces any payment method currently on file for this customer."
    :data-cy="dataCy"
    @update:checked="(v) => emit('update:modelValue', v)"
  />
</template>

<script setup lang="ts">
import Toggle from "@/components/Seranova/Toggle/Toggle.vue";

withDefaults(
  defineProps<{
    modelValue: boolean;
    dataCy?: string;
  }>(),
  {
    dataCy: undefined
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();
</script>
